import { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { getCategoryBySlug } from "@/mocks/categories";
import { getArticlesByCategory, articles as allArticles } from "@/mocks/articles";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import ArticleCard from "@/components/feature/ArticleCard";
import Breadcrumb from "@/components/feature/Breadcrumb";
import type { BreadcrumbItem } from "@/components/feature/Breadcrumb";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const category = getCategoryBySlug(slug || "");
  const [articles, setArticles] = useState(allArticles);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (slug) {
      setArticles(getArticlesByCategory(slug));
    }
  }, [slug]);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-950 mb-4">分类不存在</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 transition-colors">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
        <ScrollToTop />
      </>
    );
  }

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: "首页", href: "/" },
    { label: category.name },
  ];

  return (
    <>
      <Navbar />
      <main className="pt-24 md:pt-28 pb-14 md:pb-20">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            <div className="mb-10 md:mb-14">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg">
                  <i className={`${category.icon} text-2xl md:text-3xl`}></i>
                </div>
                <div>
                  <h1
                    className="text-2xl md:text-4xl font-bold text-foreground-950"
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    {category.name}
                  </h1>
                  <p className="text-sm md:text-base text-foreground-600 mt-1">
                    {category.description}
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>

            {articles.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}